/* Generate a comparison PDF from the products currently selected on the page. */
window.JovikidsComparisonPdf = {
  async download(products, labels) {
    if (!window.jspdf?.jsPDF) throw new Error('PDF library did not load');
    if (!Array.isArray(products) || products.length < 2) throw new Error('Select at least two products');
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const pageW = 297, pageH = 210, margin = 12, labelW = 48, headerH = 58;
    const productW = (pageW - margin * 2 - labelW) / products.length;
    const text = value => String(value == null || value === '' ? '—' : value).replace(/\s+/g, ' ').trim();
    const wrap = (value, width) => doc.splitTextToSize(text(value), Math.max(8, width - 5));
    const titleImage = value => {
      const scale = 6;
      const width = Math.round((productW - 12) * scale);
      const canvas = document.createElement('canvas');
      canvas.width = width;
      const ctx = canvas.getContext('2d');
      if (!ctx) return null;
      ctx.font = '700 17px Arial, sans-serif';
      const clean = text(value).normalize('NFKC').replace(/[\u00ad\u200b-\u200d\ufeff]/g, '').replace(/[\u2010-\u2015\u2212]/g, '-');
      const maxWidth = width * .68;
      const lines = [];
      let line = '';
      for (const word of clean.split(' ')) {
        const next = line ? `${line} ${word}` : word;
        if (line && ctx.measureText(next).width > maxWidth) {
          lines.push(line);
          line = word;
        } else line = next;
      }
      if (line) lines.push(line);
      canvas.height = Math.max(28, Math.min(lines.length, 4) * 24 + 4);
      ctx.font = '700 17px Arial, sans-serif';
      ctx.fillStyle = '#141414';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      lines.slice(0, 4).forEach((part, index) => ctx.fillText(part, width / 2, 2 + index * 24, width - 16));
      return { data: canvas.toDataURL('image/png'), height: canvas.height / scale };
    };
    const images = await Promise.all(products.map(async product => {
      if (!product.image) return null;
      try {
        const response = await fetch(product.image, { mode: 'cors' });
        if (!response.ok) return null;
        const blob = await response.blob();
        return await new Promise(resolve => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        });
      } catch (_) { return null; }
    }));
    const drawHeader = (continued = false) => {
      doc.setFillColor(255, 200, 0);
      doc.rect(0, 0, pageW, 5, 'F');
      doc.setTextColor(20, 20, 20);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      doc.text('JOVIKIDS | Product Comparison', margin, 19);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.setTextColor(100, 100, 100);
      doc.text(`${products.length} selected products${continued ? ' | Continued' : ''}`, margin, 26);
      doc.text(new Date().toLocaleDateString('en-GB'), pageW - margin, 26, { align: 'right' });
      let y = 31;
      doc.setFillColor(251, 248, 240);
      doc.rect(margin, y, pageW - 2 * margin, headerH, 'F');
      products.forEach((product, index) => {
        const x = margin + labelW + index * productW;
        const image = images[index];
        if (image) {
          try {
            const props = doc.getImageProperties(image);
            const ratio = Math.min(25 / props.width, 25 / props.height);
            const w = props.width * ratio, h = props.height * ratio;
            doc.addImage(image, props.fileType || 'JPEG', x + (productW - w) / 2, y + 2 + (25 - h) / 2, w, h);
          } catch (_) { /* Keep the title if an image format is unsupported. */ }
        }
        const title = titleImage(product.title);
        if (title) doc.addImage(title.data, 'PNG', x + 6, y + 32, productW - 12, title.height);
      });
      return y + headerH;
    };
    let y = drawHeader();
    labels.forEach((label, rowIndex) => {
      doc.setFontSize(8.5);
      const labelLines = wrap(label, labelW);
      const valueLines = products.map(product => wrap(product.specs?.[label], productW));
      const lines = Math.max(labelLines.length, ...valueLines.map(value => value.length));
      const height = Math.max(11, lines * 4 + 5);
      if (y + height > pageH - 16) {
        doc.addPage();
        y = drawHeader(true);
      }
      if (rowIndex % 2 === 0) {
        doc.setFillColor(250, 250, 250);
        doc.rect(margin, y, pageW - margin * 2, height, 'F');
      }
      doc.setDrawColor(220, 220, 220);
      doc.line(margin, y + height, pageW - margin, y + height);
      doc.setTextColor(25, 25, 25);
      doc.setFont('helvetica', 'bold');
      doc.text(labelLines, margin + 2, y + 5);
      doc.setFont('helvetica', 'normal');
      valueLines.forEach((lines, index) => {
        doc.text(lines, margin + labelW + index * productW + productW / 2, y + 5, { align: 'center' });
      });
      y += height;
    });
    const pageCount = doc.internal.getNumberOfPages();
    for (let page = 1; page <= pageCount; page++) {
      doc.setPage(page);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.setTextColor(125, 125, 125);
      doc.text('Specifications shown as displayed on jovikids.com at the time of download.', margin, pageH - 7);
      doc.text(`${page} / ${pageCount}`, pageW - margin, pageH - 7, { align: 'right' });
    }
    doc.save(`Jovikids-Product-Comparison-${new Date().toISOString().slice(0, 10)}.pdf`);
  }
};
